import { render, staticRenderFns } from "./bulletin-board.vue?vue&type=template&id=0d4583e8&scoped=true&"
import script from "./bulletin-board.vue?vue&type=script&lang=ts&"
export * from "./bulletin-board.vue?vue&type=script&lang=ts&"
import style0 from "./bulletin-board.vue?vue&type=style&index=0&id=0d4583e8&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d4583e8",
  null
  
)

export default component.exports